import {DLSelect} from '@wallaby-ui/core';
import {isEqual} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './ScreenSwitcher.less';

class ScreenSwitcher extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      options: [],
      prevScreenIds: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEqual(props.screenIds, state.prevScreenIds)) {
      return {
        options: props.screenIds.map((screenId) => ({
          value: screenId,
          label: screenId,
        })),
        prevScreenIds: props.screenIds,
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  handleChange(screenId) {
    const {onChange} = this.props;
    const ownValue = screenId ? screenId.value : null;
    if (screenId) {
      onChange(ownValue);
    }
  }

  render() {
    const {selectedScreenId} = this.props;
    const {options} = this.state;
    return (
      <DLSelect
        className={styles.dlScreenSwitcher}
        options={options}
        selectedValue={selectedScreenId}
        onChange={this.handleChange}
      />
    );
  }
}

ScreenSwitcher.displayName = 'ScreenSwitcher';

ScreenSwitcher.propTypes = {
  screenIds: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  selectedScreenId: PropTypes.string,
};

ScreenSwitcher.defaultProps = {
  screenIds: [],
  selectedScreenId: '',
};

export default ScreenSwitcher;
